<template>
<div>
	<div v-for="dialog in dialogs" :key="dialog.id">
		<div class="box">
			<myDialog
				:dialog-name="dialog.name"
				:dialog-id="dialog.id"
				:dialog-description="dialog.description"
				:dialog-questions="dialog.questions">
			</myDialog>
		</div>
	</div>
</div>
</template>

<script>

import myDialog from './myDialog.vue';

export default {
	name: 'dialogs',
	data() {
		return {
			session: {
				apiKey: sessionStorage.getItem('apiKey'),
				userId: sessionStorage.getItem('userId'),
			},
		};
	},
	components: {
		myDialog,
	},
	computed: {
		error() {
			return this.$store.state.error;
		},
		user() {
			return this.$store.state.user;
		},
		success() {
			return this.$store.state.status;
		},
		dialogs() {
			return this.$store.state.profile.dialog.dialogs;
		},
	},
};
</script>




// WEBPACK FOOTER //
// _source/javascripts/modules/profile/dialogs.vue